/**
 * Product defaults that are not per-environment. Values that will become per-user or per-firm settings say so;
 * until then they live here, never as literals in components.
 */
export const appConfig = {
  /** Number and date formats (FR-PROJ-089): Indian digit grouping, DD/MM/YYYY. Per-user from the profile later. */
  locale: "en-IN",
  /** Default time zone until the user sets one in their profile (FR-PROJ-089, FR-PROJ-121). */
  timeZone: "Asia/Kolkata",
  /** Hover delay before a tooltip opens, in ms. */
  tooltipDelayMs: 400,
  /** Gap between a trigger and its floating panel (menu, popover, select, tooltip), in px. */
  overlayOffsetPx: 6,
  /** How often long-open pages refresh relative times ("5 min ago"), in ms. */
  relativeTimeRefreshMs: 60_000,
  /** Delivery phase the product is in (06-delivery-plan.md); later features show as coming (FR-DRAFT-012). */
  currentPhase: 1,
  /** Most decimals an exact measurement shows (areas, lengths); trailing zeros are dropped, nothing is rounded away. */
  exactFractionDigits: 6,
  /** How long a toast stays before it dismisses itself, in ms. */
  toastDurationMs: 5_000,
  /** Wheel events less than this far apart belong to one gesture, which keeps its pan or zoom meaning, in ms. */
  wheelGestureHoldMs: 200,
  projects: {
    /** Window for "milestones due soon" on the Projects page (FR-PROJ-003), in days. */
    soonDays: 14,
    /** Recent projects listed in switchers and the palette (FR-PROJ-057). */
    recentLimit: 8,
  },
  /** Studio's work screens in the browser's own stand-in (`VITE_STUDIO_MODE=mock`); the services set their own. */
  studioWork: {
    /** The register's document types, as the doc service's default (`ORTHOS_DOC_REGISTER_ALLOWED_EXTENSIONS`). */
    registerExtensions: [
      "pdf",
      "png",
      "jpg",
      "jpeg",
      "gif",
      "tif",
      "tiff",
      "webp",
      "doc",
      "docx",
      "xls",
      "xlsx",
      "ppt",
      "pptx",
      "odt",
      "ods",
      "odp",
      "rtf",
      "txt",
      "csv",
    ],
    /** Import columns whose heading holds one of these words are money and are never read (D-004). */
    moneyWords: [
      "fee",
      "fees",
      "cost",
      "costs",
      "budget",
      "price",
      "rate",
      "amount",
      "invoice",
      "payment",
      "billing",
      "billable",
      "value",
      "rupees",
      "inr",
      "usd",
      "gst",
      "tax",
    ],
    /** Rows an import's preview shows. */
    previewRows: 20,
  },
} as const;
